import { computed, Directive, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { cva, type VariantProps } from 'class-variance-authority';

import type { ClassValue } from 'clsx';

export const alertDescriptionVariants = cva('tw-text-sm [&_p]:tw-leading-relaxed tw-mb-0', {
    variants: {}
});
export type AlertDescriptionVariants = VariantProps<typeof alertDescriptionVariants>;

@Directive({
    selector: '[hlmAlertDesc],[hlmAlertDescription]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    }
})
export class HlmAlertDescriptionDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() => sonaHlm(alertDescriptionVariants(), this.userClass()));
}
